export default "__VITE_ASSET__WPf6uhF0__"